<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #newUnitSetForm="ngForm" class="modal-form" novalidate>
    <div class="col-md-12 col-sm-12 p-0">
      <fieldset class="field-set">
        <legend>{{ "general" | translate }}</legend>
        <div class="row m-0">
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <div class="col-md-3 col-sm-12">
                <label for="unitSetCode">
                  <small
                    >{{ "code" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
              </div>
              <div class="col-md-9 col-sm-12">
                <input
                  type="text"
                  [disabled]="isReadOnly"
                  class="form-control form-control-sm"
                  #focusElement
                  #unitSetCode="ngModel"
                  name="unitSetCode"
                  [ngClass]="
                    alertShow && unitSetCode.invalid ? 'errorInput' : ''
                  "
                  [(ngModel)]="entity.code"
                  id="unitSetCode"
                  maxlength="10"
                  required
                />
                <div
                  *ngIf="alertShow && unitSetCode.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-3 col-sm-12">
                <label for="unitSetName">
                  <small
                    >{{ "description" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
              </div>
              <div class="col-md-9 col-sm-12">
                <input
                  type="text"
                  [disabled]="isReadOnly"
                  class="form-control form-control-sm"
                  name="unitSetName"
                  #unitSetName="ngModel"
                  [ngClass]="
                    alertShow && unitSetName.invalid ? 'errorInput' : ''
                  "
                  [(ngModel)]="entity.description"
                  id="unitSetName"
                  maxlength="50"
                  required
                />
                <div
                  *ngIf="alertShow && unitSetName.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="unitSetUnit" class="col-md-3 col-sm-12">
                <small
                  >{{ "master_unit" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-9 col-sm-12">
                <p-dropdown
                  [emptyFilterMessage]="'not_found' | translate"
                  [options]="units"
                  [disabled]="isReadOnly"
                  [(ngModel)]="entity.master_unit"
                  required
                  name="unitSetUnit"
                  #unitSetUnit="ngModel"
                  [ngClass]="
                    alertShow && unitSetUnit.invalid ? 'errorSelect' : ''
                  "
                  id="unitSetUnit"
                  dataKey="id"
                  optionLabel="description"
                  [style]="{ width: '100%' }"
                  [filter]="true"
                  placeholder="{{ 'unselected' | translate }}"
                >
                  <ng-template let-unit pTemplate="item">
                    <div class="ui-helper-clearfix">
                      <div style="font-size: 14px">{{ unit.label }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <div
                  *ngIf="alertShow && unitSetUnit.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="field-set">
        <legend>{{ "units" | translate }}</legend>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="w-100">
              <div
                class="col-md-12 col-sm-12 row position-relative pr-0 mr-0 mb-2"
              >
                <button
                  *ngIf="!isReadOnly"
                  class="btn btn-default mb-1 btn-sm"
                  (click)="addNewRow()"
                >
                  {{ "add_new_line" | translate }} +
                </button>
              </div>
              <kl-form-entry-grid
                [actionButton]="isReadOnly"
                [collectionView]="unitCollectionView"
                [allowResizing]="'Both'"
                [setMaxWidth]="true"
                [deferResizing]="false"
                [selectionColumn]="1"
                [isReadOnly]="isReadOnly"
                [viewableRowCount]="5"
                (onAddNew)="addNewRow($event)"
                (onLostFocus)="unitColumnChange($event)"
                (onCellEdit)="unitCellEdit($event)"
                (onColumnChange)="unitColumnChange($event)"
                [columns]="[
                  {
                    header: 'unit_code' | translate,
                    binding: 'unit.id',
                    width: '*',
                    dataMap: unitList,
                    showDropDown: true
                  },
                  {
                    header: 'multiplier' | translate,
                    binding: 'multiplier',
                    width: '*',
                    maxLength: 8
                  }
                ]"
              ></kl-form-entry-grid>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </form>
</kl-form-container>
